import React, { Fragment, useState } from 'react'
import { injectIntl, FormattedMessage, IntlShape } from 'react-intl'
import styled from 'styled-components'
import { CouponsSlider } from 'app/common/coupons-slider'
import { useSelector } from 'react-redux'
import type { RootState } from 'shared/store/reducers'
import { H2, Text } from 'app/common/typography'
import { media } from 'app/assets/styles'
import { CircleQuestion } from 'app/assets/icons'
import { TutorialModal } from 'app/kingdom/privileges/modals'
import { breakpoints } from 'app/assets/styles'
import { kingdomCouponsSelector } from 'shared/store/kingdom/privileges'

const { small } = breakpoints

type Props = {
    intl: IntlShape
}

const _Privileges = (props: Props) => {
    const { intl } = props

    const { showTuto } = useSelector(
        (state: RootState) => state.kingdomPrivilegesPageState
    )
    const kingdomCoupons = useSelector(kingdomCouponsSelector)

    const [state, setState] = useState({
        isPrivilegesTutoOpen: showTuto,
        windowWidth: window.innerWidth
    })

    const { isPrivilegesTutoOpen, windowWidth } = state

    const openTutorialModal = () => {
        setState({ isPrivilegesTutoOpen: true, windowWidth: window.innerWidth })
    }

    const closeTutorialModal = () => {
        setState({
            isPrivilegesTutoOpen: false,
            windowWidth: window.innerWidth
        })
    }

    return (
        <Fragment>
            {kingdomCoupons.length > 0 ? (
                <>
                    <TitleBar>
                        <StyledH2>
                            {intl.formatMessage({
                                id: 'kingdom.privileges.title'
                            })}
                        </StyledH2>
                        <IconContainer onClick={openTutorialModal}>
                            <CircleQuestion />
                        </IconContainer>
                    </TitleBar>
                    <CouponsSlider coupons={kingdomCoupons} />
                    <TutorialModal
                        isOpen={isPrivilegesTutoOpen}
                        mobile={windowWidth < small}
                        handleClose={closeTutorialModal}
                    />
                </>
            ) : (
                <NoPrivilegesContainer>
                    <FormattedMessage id="kingdom.no.privileges.title">
                        {(text: string) => <Text>{text}</Text>}
                    </FormattedMessage>
                </NoPrivilegesContainer>
            )}
        </Fragment>
    )
}

const NoPrivilegesContainer = styled.div`
    width: 100%;
    margin: 20px 0 30px;
    text-align: center;
`

const TitleBar = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const StyledH2 = styled(H2)`
    text-align: center;
    ${media.medium`
        margin-top: 0;
    `};
`

const IconContainer = styled.div`
    cursor: pointer;
    margin-left: 20px;
`

const Privileges = injectIntl(_Privileges)

export { Privileges }
